import { PurchaseOrderDetailDto, PurchaseOrderHeaderDto } from "src/dtos/purchaseOrder/purchaseOrderDto";
import { WmsOrderDetailDto, WmsOrderHeaderDto } from "src/dtos/wmsOrder/wmsOrderDto";
import { WmsTransportDetailDto, WmsTransportHeaderDto } from "src/dtos/wmsTransport/wmsTransportDto";
import { getFutureWeekdayExceptTodayAndTomorrow } from "src/utils/date/dateUtils";
import { formatDate } from "src/utils/string/stringUtil";

export interface WMS1140_R01Dto {
	wmsTransportHeaderDto: WMS1140_R01HeaderDto;
	wmsTransportDetailDtoList: WMS1140_R01DetailDto[];
}

export interface WMS1140_R01HeaderDto extends WmsTransportHeaderDto {

}

export const defaultWMS1140_R01HeaderDto: WMS1140_R01HeaderDto = {
	valueIndex: 0,
	orderIndex: 0,
	orderIndexSeq: 0,

	transportNo: '',
	compCd: '',
	compNm: '',	
	logicCenter: '',
	warehouseCd: '',
	warehouseNm: '',
	transportDt: formatDate(new Date()),
	inoutType: '',
	inoutClass: '',
	customCd: '',
	customNm: '',
	otherLogicCenter: '',
	inoutMethod: '',
	empNo: '',
	empNm: '',
	transAmt: 0,
	vatAmt: 0,
	totalAmt: 0,
	telNo: '',
	faxNo: '',
	email: '',
	post: '',
	address: '',
	otherAddress: '',
	trackingNo: '',
	approveFlg: '',
	remark: '',

	inserted: false,
	isModified: false
}

// 구매주문 상세 DTO (단일 상속 방식)
export interface WMS1140_R01DetailDto extends WmsTransportDetailDto {
	lotNo: string;
	printed: boolean;  // 라벨 출력 여부
	/** 품목 보관위치(로케이션) - 라벨 storageLocation용 */
	locationCd?: string;
	locationNm?: string;
}



export const defaultWMS1140_R01DetailDto: WMS1140_R01DetailDto = {
	valueIndex: 0,
	orderIndex: 0,
	orderIndexSeq: 0,

	transportNo: '',
	itemNo: '',
	compCd: '',
	compNm: '',
	logicCenter: '',
	transportDt: formatDate(new Date()),
	inoutType: '',
	itemCd: '',
	itemNm: '',
	itemSpec: '',
	itemStatus: '',
	unit: '',
	qty: 0,
	cost: 0,
	amt: 0,
	basOrderType: '',
	basOrderNo: '',
	basOrderItemNo: '',
	remark: '',

	lotNo: '',
	printed: false,
	locationCd: '',
	locationNm: '',

	inserted: false,	
	isModified: false
}
